"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.reduceMonthTransactions = exports.getUniqueTxnTypeList = exports.getCurrentMonthData = exports.weekDays = exports.shortWeekDays = exports.dateFormat = exports.monthFormat = exports.yearFormat = void 0;
const luxon_1 = require("luxon");
const immutable_1 = require("immutable");
const transactions_1 = require("companion-app-components/flux/transactions");
const utils_1 = require("data/transactions/utils");
exports.yearFormat = 'yyyy';
exports.monthFormat = 'MM';
exports.dateFormat = { full: `${exports.yearFormat}-${exports.monthFormat}`, friendly: `MMMM ${exports.yearFormat}` };
exports.shortWeekDays = ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'];
exports.weekDays = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
const getCurrentMonthData = (year = undefined, month = undefined) => {
    const curMonthStr = (year && month) ? `${year}-${month}` : luxon_1.DateTime.local().toFormat(exports.dateFormat.full);
    const curMonthToSet = luxon_1.DateTime.fromFormat(curMonthStr, exports.dateFormat.full);
    const prevDaysOffset = exports.weekDays.findIndex((x) => x === curMonthToSet.weekdayLong);
    const startIntervalDate = curMonthToSet.minus({ days: prevDaysOffset });
    const availableRows = prevDaysOffset + curMonthToSet.daysInMonth > 35 ? 6 : 5; // 42 = 6*7 spaces | 35 = 5*7 spaces
    const endIntervalDate = startIntervalDate.plus({ days: availableRows * 7 });
    return ({
        date: curMonthToSet,
        dateStr: curMonthStr,
        name: curMonthToSet.toFormat(exports.dateFormat.friendly),
        days: curMonthToSet.daysInMonth,
        startIntervalDate,
        endIntervalDate,
    });
};
exports.getCurrentMonthData = getCurrentMonthData;
const getUniqueTxnTypeList = (txnList, incomeCOAIds) => {
    const dayTxnTypeList = txnList.map((txn) => {
        const type = (0, utils_1.getCalendarTxnType)(txn, incomeCOAIds);
        const isIncome = parseFloat(txn.amount) > 0.0;
        // @ts-expect-error: Property 'calTxnLabelTypes' does not exist on type 'typeof transactionsTypes'.
        return (type === transactions_1.transactionsTypes.calTxnLabelTypes.overdue
            // @ts-expect-error: Property 'calTxnLabelTypes' does not exist on type 'typeof transactionsTypes'.
            || type === transactions_1.transactionsTypes.calTxnLabelTypes.expense) ? { id: txn.id, type } : { id: txn.id, type, isIncome };
    });
    const keys = ['type', 'isIncome'];
    return dayTxnTypeList.reduce((uniqueTxnTypeList, txnType) => {
        const hasTxnType = uniqueTxnTypeList.find((txnTypeItem) => keys.every((key) => txnTypeItem[key] === txnType[key]));
        if (!hasTxnType)
            uniqueTxnTypeList.push(txnType);
        return uniqueTxnTypeList;
    }, []);
};
exports.getUniqueTxnTypeList = getUniqueTxnTypeList;
const reduceMonthTransactions = (transactionsData, currentMonthData) => {
    const monthInterval = luxon_1.Interval.fromDateTimes(currentMonthData.startIntervalDate, currentMonthData.endIntervalDate).splitBy({ days: 1 });
    // @ts-expect-error: Index signature for type 'string' is missing in type 'any[]
    const datesIntervalMap = (0, immutable_1.OrderedMap)(monthInterval.map((d) => [d.start.toISODate(), (0, immutable_1.List)()]));
    return transactionsData.reduce((map, x) => {
        const txnDate = luxon_1.DateTime.fromISO(x.postedOn).toISODate();
        return map.has(txnDate) ? map.set(txnDate, map.get(txnDate).push(x)) : map;
    }, datesIntervalMap);
};
exports.reduceMonthTransactions = reduceMonthTransactions;
